import { IXactimateToolRowData } from "../shared/common/Azure";
import RestAPI from "./restAPI";

export const fetchXactimateMappingsForLineItem = async (lineItemTemplateId: string): Promise<IXactimateToolRowData[]> => {
	return (await RestAPI.fetchRebuildAPI("/rest/tools/xactimateMappings", "GET", { lineItemTemplateId })) ?? [];
};

export const updateXactimateMapping = async (mapping: IXactimateToolRowData): Promise<boolean> => {
	const success = await RestAPI.fetchRebuildAPI(`/rest/tools/xactimateMappings/${mapping.id}`, "POST", { mappingData: mapping }, "success");
	return success === true;
};

export const deleteXactimateMapping = async (id: string): Promise<boolean> => {
	const success = await RestAPI.fetchRebuildAPI(`/rest/tools/xactimateMappings/${id}`, "DELETE", {}, "success");
	return success === true;
};
